/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { NavLink, useNavigate, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import _ from 'lodash';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Chip,
  Collapse,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material';
import { spacing } from '@mui/system';
import { withStyles } from '@mui/styles';
import Loading from '../components/Loading';
import axios from '../../CustomAxios';
import SessionLogsFilter from './PastLogFilter';
import { connect } from 'react-redux';
import moment from 'moment';
import { LoadingButton } from '@mui/lab';

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);
const StyledTableContainer = withStyles((theme) => ({
  root: {},
}))(TableContainer);

function createData(id, user_type, user_details, role_info, company_details, sessions) {
  return {
    id,
    user_type,
    user_details,
    role_info,
    company_details,
    sessions,
  };
}
function buildGoogleMapURL(coordinates) {
  return `https://www.google.com/maps/place/${coordinates?.latitude},${coordinates?.longitude}`;
}
function durationBetweenTime(t1, t2) {
  let duration = '';
  let diff = moment(new Date(t2)).diff(moment(new Date(t1)), 'second');
  duration = diff + ` Second${diff > 1 ? 's' : ''}`;
  if (diff > 59) {
    diff = moment(new Date(t2)).diff(moment(new Date(t1)), 'minute');
    duration = diff + ` Minute${diff > 1 ? 's' : ''}`;
    if (diff > 59) {
      diff = moment(new Date(t2)).diff(moment(new Date(t1)), 'hour');
      duration = diff + ` Hour${diff > 1 ? 's' : ''}`;
    }
  }
  return duration;
}
const headCells = [
  { key: 'id', alignment: 'left', label: 'Sr. No' },
  { key: 'user_type', alignment: 'left', label: 'User Type' },
  { key: 'user_name', alignment: 'left', label: 'User Name' },
  { key: 'email_address', alignment: 'left', label: 'Email Address' },
  { key: 'company', alignment: 'left', label: 'Company' },
  { key: 'role', alignment: 'left', label: 'Role' },
  { id: 'sessions', alignment: 'center', label: 'Sessions' },
  { id: 'collapse', alignment: 'center', label: '' },
];
const EnhancedTableHead = () => {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? 'none' : 'normal'}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const getCompanies = async (setCompany) => {
  try {
    const authData = JSON.parse(localStorage.getItem('AuthData'));
    const config = {
      headers: {
        Authorization: 'Bearer ' + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/customer_company?limit=500`,
      config
    );
    if (data.success) {
      setCompany(data.data.data);
    }
  } catch (e) {
    console.log(e);
  }
};

const getApCompanies = async (setApCompany) => {
  try {
    const userData = JSON.parse(localStorage.getItem('AuthData'));
    const config = {
      headers: {
        Authorization: 'Bearer ' + userData.access_token,
      },
    };

    const companydata = await axios.get(`/api/v1/${userData.type}/ap_company`, config);
    if (companydata.data.success) {
      setApCompany(companydata.data.data.data);
    }
  } catch (e) {
    console.log(e);
  }
};

const EnhancedTableToolbar = (props) => {
  const [customerCompany, setCustomerCompany] = useState([]);
  const [apCompany, setApCompany] = useState([]);
  const {
    createdDateFrom,
    createdDateTo,
    selectedCompanyType,
    selectedCustomerCompany,
    selectedApCompany,
    userSearchInput,
    setUserSearchInput,
    fetchSessionLogs,
    setSelectedCustomerCompany,
    setSelectedCompanyType,
    setSelectedApCompany,
    setCreatedDateFrom,
    setCreatedDateTo,
    csvDownloading,
    downloadCsvData,
  } = props;

  useEffect(() => {
    getCompanies(setCustomerCompany);
    getApCompanies(setApCompany);
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        fetchSessionLogs(userSearchInput);
      }}
    >
      <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant='h6' id='tableTitle'>
          Past Session Logs
        </Typography>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <LoadingButton
            loading={csvDownloading}
            variant='outlined'
            sx={{ ml: 2, mr: 2 }}
            startIcon={<DownloadIcon />}
            loadingPosition='start'
            onClick={downloadCsvData}
          >
            {csvDownloading ? 'Downloading' : 'CSV'}
          </LoadingButton>
          <TextField
            value={userSearchInput}
            size='small'
            sx={{ margin: '0 8px' }}
            label='Search Users'
            placeholder='User Name'
            onChange={(e) => {
              setUserSearchInput(e.target.value);
            }}
          />
          <Button endIcon={<SearchIcon />} variant='contained' type='submit' sx={{ mr: 2 }}>
            Search
          </Button>
          <div>
            <SessionLogsFilter
              customerCompany={customerCompany}
              apCompany={apCompany}
              createdDateFrom={createdDateFrom}
              createdDateTo={createdDateTo}
              selectedCompanyType={selectedCompanyType}
              selectedCustomerCompany={selectedCustomerCompany}
              selectedApCompany={selectedApCompany}
              userSearchInput={userSearchInput}
              setUserSearchInput={setUserSearchInput}
              fetchSessionLogs={fetchSessionLogs}
              setSelectedCustomerCompany={setSelectedCustomerCompany}
              setSelectedCompanyType={setSelectedCompanyType}
              setSelectedApCompany={setSelectedApCompany}
              setCreatedDateFrom={setCreatedDateFrom}
              setCreatedDateTo={setCreatedDateTo}
            />
          </div>
        </div>
      </Toolbar>
    </form>
  );
};

function EnhancedTable({
  csvDownloading,
  downloadCsvData,
  createdDateFrom,
  createdDateTo,
  selectedCompanyType,
  selectedCustomerCompany,
  selectedApCompany,
  userSearchInput,
  setUserSearchInput,
  fetchSessionLogs,
  setSelectedCustomerCompany,
  setSelectedCompanyType,
  setSelectedApCompany,
  setCreatedDateFrom,
  setCreatedDateTo,
  rows,
  handleChangePage,
  total_results,
  rowsPerPage,
  handleChangeRowsPerPage,
  page,
}) {
  const [openCol, setOpenCol] = useState(-1);

  return (
    <Paper sx={{ pt: 2, px: 1 }}>
      <EnhancedTableToolbar
        csvDownloading={csvDownloading}
        downloadCsvData={downloadCsvData}
        createdDateFrom={createdDateFrom}
        createdDateTo={createdDateTo}
        selectedCompanyType={selectedCompanyType}
        selectedCustomerCompany={selectedCustomerCompany}
        selectedApCompany={selectedApCompany}
        userSearchInput={userSearchInput}
        setUserSearchInput={setUserSearchInput}
        fetchSessionLogs={fetchSessionLogs}
        setSelectedCustomerCompany={setSelectedCustomerCompany}
        setSelectedCompanyType={setSelectedCompanyType}
        setSelectedApCompany={setSelectedApCompany}
        setCreatedDateFrom={setCreatedDateFrom}
        setCreatedDateTo={setCreatedDateTo}
      />
      <StyledTableContainer>
        <Table size={'small'}>
          <EnhancedTableHead />
          <TableBody>
            {rows.map((row, index) => {
              return (
                <>
                  <TableRow role='checkbox' tabIndex={-1} key={`${row.id}-${index}`}>
                    <TableCell align='left'>{index + 1}</TableCell>
                    <TableCell align='left'>{_.upperCase(String(row.user_type))}</TableCell>
                    <TableCell align='left'>{row?.user_details?.name}</TableCell>
                    <TableCell align='left'>{row?.user_details?.email_address}</TableCell>
                    <TableCell align='left'>
                      {row.company_details ? row.company_details?.name : 'SELF'}
                    </TableCell>
                    <TableCell align='left'>
                      {row.role_info ? row.role_info?.role_name : 'Admin'}
                    </TableCell>
                    <TableCell align='center'>
                      <Chip
                        label={row.sessions?.length > 9 ? '9+' : row.sessions?.length}
                        color='primary'
                        size='small'
                        sx={{ borderRadius: '50%' }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        aria-label='expand row'
                        size='small'
                        onClick={() => setOpenCol(index === openCol ? -1 : index)}
                      >
                        {openCol === index ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                      <Collapse in={openCol === index} timeout='auto' unmountOnExit>
                        <Box sx={{ padding: 4, marginBottom: 4 }}>
                          <Typography variant='h6' component='div' sx={{ mb: 2 }}>
                            Sessions
                          </Typography>
                          <Table size='small' aria-label='purchases'>
                            <TableHead>
                              <TableRow>
                                <TableCell>Login Time</TableCell>
                                <TableCell>Logout Time</TableCell>
                                <TableCell>Duration</TableCell>
                                <TableCell>Location</TableCell>
                                <TableCell>Google Map</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {Array.isArray(row.sessions) &&
                                row.sessions.map((log, i) => (
                                  <TableRow key={i}>
                                    <TableCell component='th' scope='row'>
                                      {moment(new Date(log.login_time)).calendar()}
                                    </TableCell>
                                    <TableCell>
                                      {moment(new Date(log.logout_time)).calendar()}
                                    </TableCell>
                                    <TableCell>
                                      {durationBetweenTime(log.login_time, log.logout_time)}
                                    </TableCell>
                                    <TableCell>{log.login_place?.address_details}</TableCell>
                                    <TableCell>
                                      <IconButton
                                        aria-label='map-open'
                                        onClick={() => {
                                          window
                                            .open(
                                              buildGoogleMapURL(log?.login_place?.coordinates),
                                              '_blank'
                                            )
                                            .focus();
                                        }}
                                      >
                                        <OpenInNewIcon />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
      </StyledTableContainer>
      <TablePagination
        rowsPerPageOptions={[25, 50, 100]}
        component='div'
        count={total_results}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

function PastSessionLogsList() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(true);
  const [userSearchInput, setUserSearchInput] = useState('');
  const [selectedCompanyType, setSelectedCompanyType] = useState('');
  const [selectedApCompany, setSelectedApCompany] = useState(searchParams.get('company_id') || '');
  const [selectedCustomerCompany, setSelectedCustomerCompany] = useState(
    searchParams.get('company_id') || ''
  );
  const [rows, setRows] = useState([]);
  const [page, setPage] = React.useState(parseInt(searchParams.get('page')) - 1 || 0);
  const [rowsPerPage, setRowsPerPage] = React.useState(parseInt(searchParams.get('limit')) || 25);
  const [total, setTotal] = useState(0);
  const [createdDateFrom, setCreatedDateFrom] = useState(
    searchParams.get('bill_created_from') || ''
  );
  const [createdDateTo, setCreatedDateTo] = useState(searchParams.get('bill_created_to') || '');
  const [csvDownloading, setCsvDownloading] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchSessionLogs();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    fetchSessionLogs();
  };

  useEffect(() => {
    fetchSessionLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSessionLogs = async () => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + userData.access_token,
        },
      };
      const logsDataArray = [];
      let base_api_uri = `/api/v1/${userData.type}/sessions/logs`;
      let query_str = '';

      // pagination
      query_str += `?page=${page + 1}&limit=${rowsPerPage}&`;

      if (userSearchInput) {
        query_str += `user_name_text=${userSearchInput}&`;
      }
      if (selectedCompanyType) {
        query_str += `user_type_filter=${selectedCompanyType}_user&`;

        switch (selectedCompanyType) {
          case 'ap_company':
            query_str += `company_id=${selectedApCompany}&`;
            break;
          case 'customer_company':
            query_str += `company_id=${selectedCustomerCompany}&`;
            break;
          default:
            break;
        }
      }

      if (createdDateFrom) {
        const startDate = new Date(createdDateFrom);
        startDate.setHours(0, 0, 0, 0);
        query_str += `start_time=${startDate.toISOString()}&`;
      }

      if (createdDateTo) {
        const endDate = new Date(createdDateTo);
        endDate.setHours(23, 59, 59, 999);
        query_str += `end_time=${endDate.toISOString()}&`;
      }

      const { data: apiResponse } = await axios.get(base_api_uri + query_str, config);
      apiResponse.data.map((log) => {
        logsDataArray.push(
          createData(
            log._id,
            log.user_type,
            log.user_details,
            log.role_info,
            log.company_details,
            log.sessions
          )
        );
      });
      setPage(apiResponse.metadata?.page - 1);
      setTotal(apiResponse.metadata?.total_results);
      setRows(logsDataArray);
      navigate(query_str, { replace: true });
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const downloadCsvData = async () => {
    try {
      setCsvDownloading(true);
      const userData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + userData.access_token,
        },
        timeout: 5 * 60 * 1000,
        responseType: 'blob',
      };
      let base_api_uri = `/api/v1/${userData.type}/sessions/logs/csv?`;
      let query_str = '';

      if (createdDateFrom) {
        const startDate = new Date(createdDateFrom);
        startDate.setHours(0, 0, 0, 0);
        query_str += `start_time=${startDate.toISOString()}&`;
      }

      if (createdDateTo) {
        const endDate = new Date(createdDateTo);
        endDate.setHours(23, 59, 59, 999);
        query_str += `end_time=${endDate.toISOString()}&`;
      }

      const { data: csvFile } = await axios.get(base_api_uri + query_str, config);
      await saveFileToLocal(csvFile, 'session-logs');
      setCsvDownloading(false);
    } catch (e) {
      console.log(e);
      setCsvDownloading(false);
    }
  };

  async function saveFileToLocal(fileObj, fileName) {
    const current_time_tag = moment().format('YYYY-MM-DD-HH-mm');
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const url = window.URL.createObjectURL(fileObj);
    a.href = url;
    a.download = `${fileName}-${current_time_tag}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title='Alpha Plus' />
        <Grid justifyContent='space-between' alignItems='center' container spacing={10} mb={4}>
          <Grid item>
            <Typography
              variant='h4'
              gutterBottom
              display='inline'
              sx={{ fontWeight: 600 }}
              color='primary'
            >
              SESSION LOGS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label='Breadcrumb' mt={2}>
              <Link component={NavLink} to='/dashboard/tasks'>
                Dashboard
              </Link>
              <Typography> Session Logs</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable
              csvDownloading={csvDownloading}
              downloadCsvData={downloadCsvData}
              createdDateFrom={createdDateFrom}
              createdDateTo={createdDateTo}
              selectedCompanyType={selectedCompanyType}
              selectedCustomerCompany={selectedCustomerCompany}
              selectedApCompany={selectedApCompany}
              userSearchInput={userSearchInput}
              setUserSearchInput={setUserSearchInput}
              fetchSessionLogs={fetchSessionLogs}
              setSelectedCustomerCompany={setSelectedCustomerCompany}
              setSelectedCompanyType={setSelectedCompanyType}
              setSelectedApCompany={setSelectedApCompany}
              setCreatedDateFrom={setCreatedDateFrom}
              setCreatedDateTo={setCreatedDateTo}
              rows={rows}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              total_results={total}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(PastSessionLogsList);
